import { User } from "../model/User"

export const SetUser = (user:User) => {
    return {
        type: 'SET_USER',
        value: user
    }
}